import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CiLock } from "react-icons/ci";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { forgotResetSuperAdminPassword } from "../../services/LoginAuthService/LoginAuthService";

const ForgotResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");   
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { token: resetToken } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = {};

    if (!newPassword) validationErrors.newPassword = "Required";
    if (!confirmPassword) validationErrors.confirmPassword = "Required";
    if (newPassword !== confirmPassword) {
      validationErrors.confirmPassword = "Passwords must match";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      await forgotResetSuperAdminPassword(
        {
          new_password: newPassword,
          confirm_password: confirmPassword,
        },
        resetToken // Pass the resetToken here
      );
      navigate("/");
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error.message);
      setErrors({ api: error.message || "Password reset failed" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-900 background w-full h-[100vh] flex items-center">
      <div className="flex justify-center mx-auto w-full h-[50vh] rounded-xl">
        <div className="z-10 relative flex flex-col justify-center w-3/5 px-10">
        <div className="absolute -z-10 inset-0 border-2 border-red-600 rounded-xl backdrop-blur-sm bg-red-500/50"></div>
          <div className="flex flex-col gap-5">
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex justify-center">
            <img
              src={require("../../assets/images/commonImages/ZeroMiddleMan Logo 3.png")}
              alt=""
              className="bg-white px-4 rounded-2xl w-32 md:w-48"
            />
          </div>

            <div className="flex flex-col">
              <label className="text-white font-semibold text-lg">New Password</label>
              <div className="relative">
                <input
                  className="px-5 py-2 text-white placeholder-white outline-none border-b bg-transparent w-full"
                  type={newPassword ? "text" : "password"}
                  placeholder="Enter your Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
            </div>

            <div className="flex flex-col">
              <label className="text-white font-semibold text-lg">Confirm Password</label>
              <div className="relative">
                <input
                  className="px-5 py-2 text-white placeholder-white outline-none border-b bg-transparent w-full"
                  type={confirmPassword ? "text" : "password"}
                  placeholder="Confirm your Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-center mt-5">
            <button
              className="px-10 py-2 bg-white font-semibold text-xl text-[#ff0000] hover:bg-[#d93030] hover:text-white rounded-md"
              type="button"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Reset Password"}
            </button>
          </div>
          {errors.api && <p className="text-white text-sm text-center mt-2">{errors.api}</p>}
        </div>
      </div>
    </div>
  );
};
export default ForgotResetPassword;